export const COMMAND_EFFECT_REQUEST = {
  /**
   * instead of showing error, just navigate to needed step and focus input
   */
  GS1_NEED_TO_ENTER_TITLE: 'GS1_NEED_TO_ENTER_TITLE',
};
